// Includes
import NProgress from 'nprogress';
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../stores/store';
window.Pusher = require("pusher-js");

import AcolhimentosRoutes from '@modules/Acolhimento/Resources/assets/js/router';
import AtendimentoRoutes from '@modules/Atendimento/Resources/assets/js/router';
import AtividadeRoutes from '@modules/Atividade/Resources/assets/js/router';
import AditoriaRoutes from '@modules/Auditoria/Resources/assets/js/router';
import BeneficioRoutes from '@modules/Beneficio/Resources/assets/js/router';
import CalendarRoutes from '@modules/Calendar/Resources/assets/js/router';
import ConfiguracaoRoutes from '@modules/Configuracao/Resources/assets/js/router';
import DenunciaRoutes from '@modules/Denuncia/Resources/assets/js/router';
import EncaminhamentoRoutes from '@modules/Encaminhamento/Resources/assets/js/router';
import FamiliaRoutes from '@modules/Familia/Resources/assets/js/router';
import GerenciadorArquivoRoutes from '@modules/GerenciadorArquivo/Resources/assets/js/router';
import ImportacaoRoutes from '@modules/Importacao/Resources/assets/js/router';
import MapaRoutes from '@modules/Mapa/Resources/assets/js/router';
import MedidasRoutes from '@modules/Medidas/Resources/assets/js/router';
import OficioRoutes from '@modules/Oficio/Resources/assets/js/router';
import PAFRoutes from '@modules/PAF/Resources/assets/js/router';
import ProgramaSocialRoutes from '@modules/ProgramaSocial/Resources/assets/js/router';
import RealtimeRoutes from '@modules/Realtime/Resources/assets/js/router';
import ReferenciasRoutes from '@modules/Referencia/Resources/assets/js/router';
import ScfvRoutes from '@modules/Scfv/Resources/assets/js/router';
import SuporteRoutes from '@modules/Suporte/Resources/assets/js/router';
import TecnicosRoutes from '@modules/Tecnico/Resources/assets/js/router';
import TermosUsoRoutes from '@modules/TermosUso/Resources/assets/js/router';
import UnidadeRoutes from '@modules/Unidade/Resources/assets/js/router';
import UsuarioRoutes from '@modules/Usuario/Resources/assets/js/router';
import VVDRoutes from '@modules/ViolenciaViolacaoDireito/Resources/assets/js/router';
import MidiaRoutes from '@modules/Midia/Resources/assets/js/router';
import BotPressRoutes from '@modules/BotPress/Resources/assets/js/router';
import PainelGestorBIRoutes from '@modules/PainelGestorBI/Resources/assets/js/router';

//Relatórios
import RelatorioRoutes from '@modules/Relatorio/Resources/assets/js/router';

import routesArray from './routes';
// Notify to vue to use vue-router
Vue.use(VueRouter);
// Define dashboard routes
const routes = routesArray;
routes[1].children = routes[1].children
    .concat(UsuarioRoutes)
    .concat(FamiliaRoutes)
    .concat(ImportacaoRoutes)
    .concat(GerenciadorArquivoRoutes)
    .concat(AtendimentoRoutes)
    .concat(AtividadeRoutes)
    .concat(EncaminhamentoRoutes)
    .concat(ConfiguracaoRoutes)
    .concat(DenunciaRoutes)
    .concat(OficioRoutes)
    .concat(VVDRoutes)
    .concat(PAFRoutes)
    .concat(ScfvRoutes)
    .concat(MedidasRoutes)
    .concat(ReferenciasRoutes)
    .concat(BeneficioRoutes)
    .concat(ProgramaSocialRoutes)
    .concat(AcolhimentosRoutes)
    .concat(RelatorioRoutes)
    .concat(MapaRoutes)
    .concat(SuporteRoutes)
    .concat(CalendarRoutes)
    .concat(TecnicosRoutes)
    .concat(TermosUsoRoutes)
    .concat(BotPressRoutes)
    .concat(RealtimeRoutes)
    .concat(UnidadeRoutes)
    .concat(MidiaRoutes)
    .concat(AditoriaRoutes)
    .concat(PainelGestorBIRoutes);

// Set the routes in vue-router
const router = new VueRouter({
    routes,
    linkActiveClass: "active",
    mode: "history"
});



// Router auth middleware
router.beforeResolve((to, from, next) => {
    if (to.meta.middleware || to.meta.controller) {
        NProgress.start();
        if (!localStorage.getItem('token') && to.meta.middleware.includes('auth')) {
            next('/auth/login');
        } else if (localStorage.getItem('token') && to.meta.middleware.includes('guest')) {
            next('/dashboard/home');
        } else if (!store.state.register && to.meta.middleware.includes('register')) {
            next('/auth/login');
        } else if (localStorage.getItem('token') && to.meta.middleware.includes('auth')) {
            axios.post('api/auth/check', {
                controller: to.meta.controller
            }).then(function (response) {
                if (response.data.data.access) {
                    next();
                } else {
                    if (to.meta.controller) {
                        swal.fire({
                            title: "Acesso Negado",
                            text: "Você não possui permissão para acessar esta funcionalidade.",
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                        next('/dashboard/home');
                    } else {
                        next('/auth/login');
                    }
                }
                store.state.user = response.data.data.user;
                store.state.unidade = response.data.data.unidade;
                store.state.settings = response.data.data.settings;
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

gtag('set', 'page', router.currentRoute.path);
gtag('send', 'pageview');

router.afterEach((to, from) => {
    NProgress.done();
    gtag('set', 'page', to.path);
    gtag('send', 'pageview');
});


// Export router
export default router;
